import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoRouteBuilder} from '../config/repo-route-builder'
import {workflowRunsMainQuery} from '../queries/workflow-runs/workflow-runs-query'

export function buildAllWorkflowRunsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('allWorkflowRunsRoute', {
    path: '/:owner/:repo/actions',
    queries: [workflowRunsMainQuery],
  })
}

export const allWorkflowRunsRoute = buildAllWorkflowRunsRoute(repoRouteBuilder)
